<template>
    <div class="padding_dashboard dashboard">
        <div class="padding_rightpanel dashboard__rightpanel">
            <PlanCard :portfolio="selectedPortfolio"/>
            <div v-if = "(selectedPortfolio.expectedInvestmentAmount/100 - virtualAccountValue/100) > 0 && virtualAccountValue/100 < 5000">
                <p v-if = "virtualAccountValue === 0" class = "accountEmpty_text">
                    Your Account is Empty!
                </p>
                <p v-else class = "accountEmpty_text">Your Account Balance is ₹{{virtualAccountValue/100 | localeAmountNormal }}</p>
                <p v-if = "virtualAccountValue === 0" class = "deposit_text">
                    Deposit money to start your investment journey
                </p>
                <p v-else class = "deposit_text">
                    Deposit Pending money to start your investment journey
                </p>
                <div class = "change_payment_container">
                    <p v-if = "virtualAccountValue === 0" class="change_payment mb-10" @click="paymentDialogBox">Change Payment Method</p>
                </div>
                <div class = "change_payment_container">
                    <p v-if = "virtualAccountValue === 0" class="change_payment" @click="reviewPlan">Review your plan</p>
                </div>
                <div class = "paymentContainer">
                    <p class = "bankType_text">IMPS/NEFT/RTGS</p>
                    <p v-if = "(selectedPortfolio.expectedInvestmentAmount/100 - virtualAccountValue/100) >= 0" class = "amount_Text">Amount: <span class = "amount">₹{{selectedPortfolio.expectedInvestmentAmount/100 - virtualAccountValue/100 | localeAmountNormal }}</span></p>
                    <p v-else class = "amount_Text">Amount: <span class = "amount">₹0</span></p>
                </div>
                <p class = "transfer_Text">Transfer money only from this account</p>
                <div class = "bankBox">
                    <v-icon class="iconColor material-icons-round">account_balance</v-icon>
                    <div class = "accountDetailsContainer">
                        <p class = "bankName_text">{{userBankName}}</p>
                        <p class = "account_text">{{userBankAccount}}</p>
                    </div>
                </div>
                <p class = "note">Note: <span class = "noteDescription">Transfer from any other bank account will be declined and refunded within 5-7 workings days.</span></p>
                <p class = "following_bank_account">To the following bank account:</p>
                <div>
                    <div class = "contentContainer">
                        <div class = "leftContainer">
                            <p class = "white-box-heading">Account Number</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[2].value}}</p>
                                <v-icon @click="copyToClipboard(2)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                        <div class = "rightContainer">
                            <p class = "white-box-heading">IFSC code</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[3].value}}</p>
                                <v-icon @click="copyToClipboard(3)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                    </div>
                    <div class = "contentContainer">
                        <div class = "leftContainer">
                            <p class = "white-box-heading">Account Type</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[4].value}}</p>
                                <v-icon @click="copyToClipboard(4)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                        <div class = "rightContainer">
                            <p class = "white-box-heading">Account holder name</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[0].value}}</p>
                                <v-icon @click="copyToClipboard(0)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                    </div>
                    <p class = "waiting_text">It may take upto one working day to reflect in your investment account.</p>
                </div>
            </div>
            <div v-else>
                <div class = "lottiePlayerContainer">
                    <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_42mtixws.json"  background="transparent"  speed="1"  style="width: 120px; height: 120px;"  loop autoplay></lottie-player>
                    <p class = "congratulations">Congratulations</p>
                    <p class = "investmentFirst">You made your first investment with IndiaP2P</p>
                    <ValidationProvider
                        name="Amount"
                        :rules="rules"
                        v-slot="{ errors, classes }"
                    >
                        <p class="investmentAmount" :class="classes">₹<input id="inputAmount" type="tel" ref="input" v-model="withdrawAmount" v-on:input="adjustInput"/></p>
                        <div class="errorText">{{ errors[0] }}</div>
                    </ValidationProvider>
                     <!-- <p class = "investmentAmount">₹{{virtualAccountValue/100 | localeAmountNormal }}</p> -->
                </div>
            </div>
            <PayUDialog
                v-if="showPayUDialog"
                :showPayUDialog="showPayUDialog"
                @closeDialog="closePayUDialog"
            />
            <PaymentComponent
                v-if="showPaymentDialog"
                :showPaymentDialog="showPaymentDialog"
                :selectedPortfolio="selectedPortfolio"
                :transactionPurpose="'portfolio'"
                @closeDialog="closePaymentDialog"
            />
            <planSelectionDialog
                v-if = "showPlanDialog"
                :showPlanDialog="showPlanDialog"
                :selectedPortfolio="selectedPortfolio"
                @closeDialog = "closeDialog"
            />
            <v-snackbar v-model="isCopied" app timeout="8000">
            Copied to clipboard!

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isCopied = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        </div>
    </div>
</template>
<script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script>
<script>
import PayUDialog from '../common/paymentComponent/payuDialog.vue'
import PaymentComponent from '../common/paymentComponent/paymentDialog.vue'
import PlanCard from '../common/planCard/planCard.vue'
import LenderService from '@/services/lenderService'
import planSelectionDialog from '../common/planSelectionDialog.vue'

export default {
    name: 'EmptyDashboard',
    components: {
        PayUDialog,
        PaymentComponent,
        PlanCard,
        planSelectionDialog
    },
    props: {
        selectedPortfolio: Object,
        accountInfo: Object,
        showPayUDialog: Boolean
    },
    data () {
        return {
            lender: {
                name: 'Sudhanshu Sharda'
            },
            portfolio: null,
            paymentDetails: [],
            showAlternateProduct: '',
            showPaymentDialog: false,
            userBankAccount: null,
            userBankName: null,
            virtualAccountValue: 0,
            isCopied: false,
            showPlanDialog: false,
            amount: 0,
            rules: ''
        }
    },
    filters: {
        capitalize (value) {
            return value[0].toUpperCase() + value.slice(1)
        }
    },
    beforeMount () {
        this.$store.commit('isLoading')
        this.getVirtualAccountDetails()
        this.updateCustomerMetaData()
        this.getUserData()
        this.paymentDetails.push({
            label: 'Beneficiary',
            value: this.$store.state.userName || this.$store.state.onBoarding.Name
        },
        {
            label: 'Bank',
            value: 'Yes Bank'
        },
        {
            label: 'Account Number',
            value: this.accountInfo.virtualAccountNumber
        },
        {
            label: 'IFSC Code',
            value: this.accountInfo.ifsc
        },
        {
            label: 'Account Type',
            value: 'Current'
        })
        this.showAlternateProduct = (this.selectedPortfolio.planType === 'income') ? 'growth' : 'income'
    },
    mounted () {
        this.$refs.input.focus()
        this.$refs.input.style.width = (this.$refs.input.value.length) + 'ch'
        this.rules = `amountValidationLocale:${this.virtualAccountValue / 100},5000|required`
    },
    computed: {
        getPaymentDetails () {
            return [
                {
                    label: 'Beneficiary',
                    value: this.$store.state.userName || this.$store.state.onBoarding.Name
                },
                {
                    label: 'Bank',
                    value: 'Yes Bank'
                },
                {
                    label: 'Account Number',
                    value: this.accountInfo.virtualAccountNumber
                },
                {
                    label: 'IFSC Code',
                    value: this.accountInfo.ifsc
                },
                {
                    label: 'Account Type',
                    value: 'Current'
                }
            ]
        },
        getName () {
            return this.$store.state.userName || this.$store.state.onBoarding.Name
        },
        withdrawAmount: {
            get () {
                if (this.amount) {
                    return this.amount.toLocaleString('en-IN', { useGrouping: true }) || 0
                }
                return null
            },
            set (newValue) {
                const temp = parseFloat(newValue.replaceAll(',', ''))
                console.log('temp', temp)
                if (temp <= 5000000) {
                    this.amount = temp || 0
                } else {
                    this.amount = 0
                }
            }
        },
    },
    methods: {
        closeDialog () {
            location.reload()
            this.showPlanDialog = false
        },
        reviewPlan () {
            this.showPlanDialog = true
        },
        updateCustomerMetaData () {
            const payload = {}
            LenderService.updateCustomerMetaData(payload).then((response) => {
                if (response.status === 200) {
                }
            })
        },
        copyToClipboard (index) {
            navigator.clipboard.writeText(
                this.paymentDetails[index].value
            )
            this.isCopied = true
        },
        getUserData () {
            LenderService.getUserNomineeData().then((response) => {
                this.$store.commit('isLoading')
                if (response.status === 200) {
                    this.userBankAccount = response.data.result.kyc.bankAccount.bankAccountNumber
                    this.getBankName(response.data.result.kyc.bankAccount.ifsc)
                } else {
                    this.$store.commit('isNotLoading')
                }
            })
        },
        getBankName (ifsc) {
            LenderService.getIfscCode(ifsc).then((response) => {
                if (response.status === 200) {
                    this.userBankName = response.data.BANK
                    this.$store.commit('isNotLoading')
                } else if (response.status === 400) {
                    this.userBankName = 'XXXXXXXXXXXXX'
                    this.$store.commit('isNotLoading')
                } else {
                    this.$store.commit('isNotLoading')
                }
            })
        },
        closePayUDialog () {
            this.showPayUDialog = false
            this.$router.replace({ query: null })
        },
        closePaymentDialog () {
            this.showPaymentDialog = false
        },
        paymentDialogBox () {
            this.showPaymentDialog = true
        },
        getVirtualAccountDetails () {
            this.virtualAccountValue = this.accountInfo.escrowBalance
            this.amount = this.selectedPortfolio.expectedInvestmentAmount / 100
        },
        adjustInput (event) {
            // debounce(() => {
            if (event.target.value.length === 0) {
                event.target.style.width = '30px'
            } else if (event.target.value.length === 1) {
                event.target.style.width = '30px'
            } else {
                event.target.style.width = (event.target.value.length) + 'ch'
            }

            this.$emit('updatedInvestmentAmount', this.amount)
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./dashboard.scss";

.change_payment_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%
}
.padding_dashboard {
    padding-left: 100px;
    padding-right: 100px;
}
.icons {
    position: absolute;
    left: 90%;
    color: #D3D3D3 !important
}
.deposit_text {
    font-size: 13px;
    color: #8c8c8c;
    font-weight: 500;
    text-align: center;
    margin-bottom: 12px;
}
.accountEmpty_text {
    color: #232323;
    font-weight: 500;
    font-size:18px;
    text-align: center;
    margin-bottom: 2px;
}
.change_payment {
    margin-bottom: 26px;
    font-size: 13px;
    font-weight: 600 !important;
    text-align: center !important;
    color: #007AFF !important;
    text-decoration-line: underline !important;
    cursor: pointer !important;
    width: fit-content
}
.paymentContainer {
    padding-bottom: 10px;
    display: flow-root;
    flex-direction: row;
}
.bankType_text {
    float: left;
    font-weight: 700;
    font-size: 14px;
    color: #232323;
}
.amount_Text {
    float: right;
    font-weight: 700;
    font-size: 14px;
    color: #232323;

}
.amount {
    color: #002FA7 !important
}
.transfer_Text {
    font-weight: 700;
    font-size: 14px;
    color: #002FA7;
}
.bankBox {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    padding: 12px;
    padding-right: 100px;
    width: max-content;
    border-radius: 10px;
    background-color: #ffffff;
    border-style: solid;
    border-width: 1px;
    border-color: #E0E0E0;
}
.white-box {
    position: relative;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    padding: 12px;
    border-radius: 10px;
    background-color: #ffffff;
    border-style: solid;
    border-width: 1px;
    border-color: #E0E0E0;
}
.bankName_text {
    margin-bottom: 2px;
    font-weight: 600;
    font-size: 16px;
    color: #232323;

}
.account_text {
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 14px;
    color: #4F4F4F;
}
.accountDetailsContainer {
    padding-left: 20px;
}
.note {
    margin-bottom: 30px;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
}
.noteDescription {
    font-weight: 500;
    font-size: 14px;
    color: #8c8c8c;
}
.following_bank_account {
font-weight: 700;
font-size: 14px;
color: #002FA7;
}
.white-box-heading {
    margin-bottom: 12px;
    font-weight: 500;
    font-size: 12px;
    color: #4F4F4F;
}
.white-box-sub-heading {
    margin-bottom: 0px;
    font-weight: 600;
    font-size: 14px;
    color: #232323;
}
.contentContainer {
    display: flex;
    flex-direction: row;
}
.leftContainer {
    width: -webkit-fill-available !important;
    margin-right: 15px;
}

.rightContainer {
    width: -webkit-fill-available !important;
    margin-left: 15px;
}
.waiting_text {
    font-style: italic;
    font-weight: 400;
    font-size: 13px;
    color: #8C8C8C;
    text-align: right;
}
@media (max-width: 990px) {
    .contentContainer {
    display: flex;
    flex-direction: column !important;
}
    .rightContainer {
    width: -webkit-fill-available !important;
    margin-left: 0px !important;
}
    .leftContainer {
    width: -webkit-fill-available !important;
    margin-right: 0px !important;
}
    .padding_dashboard {
    padding-left: 10px !important;
    padding-right: 10px !important;
}
}
.lottiePlayerContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.congratulations {
    font-weight: 700;
    font-size: 21px;
    color: #000000;
}
.investmentFirst {
    text-align: center;
    font-weight: 500;
    font-size: 17px;
    color: #8C8C8C;
}
.investmentAmount {
    font-weight: 600;
    font-size: 24px;
    color: #232323;
    text-align: center;
}
.padding_rightpanel {
    padding-right: 0px !important;
}

input[type=tel]:focus {
        border: none;
        background-color: none;
        outline: 0;
        /* min-width: 50px;
        max-width: 240px; */
    }

    input[type=tel] {
        caret-color: #007AFF;
        min-width: 50px;
    }

.errorText {
        color: #e45f5f !important;
        font-size: 12px;
        text-align: center;
    }
</style>
